<template>
    <tbody>
    <tr is="admin-translation-row"
        v-for="(translation, index) in translations"
        :initial-translation="translation"
        :index="index"
        :key="translation.id"
        @deleteTranslation="deleteTranslation"
        :languages="languageList"
    >
    </tr>
    </tbody>
</template>
<script>
    export default {
        props: {
            initialTranslations: Object,
            languageList: Array,
        },
        data() {
            return {
                translations: JSON.parse(JSON.stringify(this.initialTranslations.data)),
            };
        },
        methods: {
            deleteTranslation(id, index) {
                this.translations.splice(index, 1)
                if (this.translations.length == 0) {
                    const urlParams = new URLSearchParams(window.location.search);
                    let pageNumber = urlParams.get('page');
                    if (pageNumber != null && pageNumber > 1) {
                        urlParams.set("page", pageNumber - 1);
                        window.location.href = location.protocol + '//' + location.host + location.pathname + '?' + urlParams.toString();
                    }
                    if (pageNumber == null || pageNumber == 1) {
                        location.reload();
                    }
                }
            }
        }
    }
</script>
